// extracted by mini-css-extract-plugin
export default {"slide":"index_slide_k1FX7","dot":"index_dot_RV5x0","current":"index_current_6Hwqw index_dot_RV5x0"};